import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { getNewsPage } from '~/lib/content/content'
import { cacheHeaders } from '~/lib/site/cache'
import { NEWS_TYPES } from '~/lib/news/types'
import type { NewsType } from '~/lib/news/types'
import {
  NEWS_TAB_LABELS,
  newsHead,
  validateNewsSearch,
} from '~/lib/news/routes'
import { NewsListing } from '~/components/sections/NewsListing'

// /news/top-press, /news/blog, /news/press-releases: each tab's page 1 is
// prerendered (vite.config.ts lists them); `?page=N` loads client-side.
const tabType = (t: string) =>
  NEWS_TYPES.find((n): n is NewsType => n !== 'all' && n === t)

export const Route = createFileRoute('/news/$type')({
  validateSearch: validateNewsSearch,
  beforeLoad: ({ params }) => {
    if (params.type === 'all') throw redirect({ to: '/news', replace: true })
    const type = tabType(params.type)
    if (!type) throw notFound()
    return { type }
  },
  loader: ({ context: { type } }) => getNewsPage({ data: { type, page: 1 } }),
  headers: () => cacheHeaders.content,
  head: ({ params }) => {
    const type = tabType(params.type)
    // An unknown tab is a 404 (beforeLoad); don't title it "News | News".
    return newsHead(type ? `${NEWS_TAB_LABELS[type]} | News` : 'News')
  },
  component: NewsTab,
})

function NewsTab() {
  const { type } = Route.useRouteContext()
  const { page, q } = Route.useSearch()
  return (
    <NewsListing
      type={type}
      page={page ?? 1}
      q={q}
      initial={Route.useLoaderData()}
    />
  )
}
